// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"937cce0f","246":"56100247","453":"3f6c1979","455":"402905f9","977":"4896053c"}[chunkId] + ".chunk.js";
};